import React from 'react';
import './TopperBanner.css';

// List of toppers
const toppers = [
  { name: 'Prakruti D/O Pratap', class: '1st Std', rank: '1st Rank', image: '1d1.jpg' },
  { name: 'Arpita D/O Basavaraj', class: '1st Std', rank: '2nd Rank', image: '1d2.jpg' },
  { name: 'Lingaraj S/O Mantesh', class: '1st Std', rank: '3rd Rank', image: '1d3.jpg' },
  { name: 'Bhoomika D/O Gurunath', class: '2nd Std', rank: '1st Rank', image: '2d1.jpg' },
  { name: 'Harish S/O Surykant', class: '2nd Std', rank: '2nd Rank', image: '2d2.jpg' },
  { name: 'Divya D/O Santosh', class: '2nd Std', rank: '3rd Rank', image: '2d3.jpg' },
  { name: 'Shrusti D/O Peerappa', class: '3rd Std', rank: '1st Rank', image: '3d1.jpg' },
  { name: 'Sakshi D/O Nagesh', class: '3rd Std', rank: '2nd Rank', image: '3d2.jpg' },
  { name: 'Umeera D/O Muhid', class: '3rd Std', rank: '3rd Rank', image: '3d3.jpg' },
  { name: 'Rabiya D/O Salavudin', class: '4th Std', rank: '1st Rank', image: '4d1.jpg' },
  { name: 'Vinuta D/O Amrut', class: '4th Std', rank: '2nd Rank', image: '4d2.jpg' },
  { name: 'Sakshi D/O Bhimashankar', class: '4th Std', rank: '3rd Rank', image: '4d3.jpg' },
  { name: 'Atiya D/O Chandasab', class: '5th Std', rank: '1st Rank', image: '5d1.jpg' },
  { name: 'Shrushti S/O Siddaram', class: '5th Std', rank: '2nd Rank', image: '5d2.jpg' },
  { name: 'Kavya D/O Shivaji', class: '5th Std', rank: '3rd Rank', image: '5d3.jpg' },
  { name: 'Bhagyashree D/O Nagesh', class: '6th Std', rank: '1st Rank', image: '6d1.jpg' },
  { name: 'Sneha D/O Nagesh', class: '6th Std', rank: '2nd Rank', image: '6d2.jpg' },
  { name: 'Juned S/O Mubarak', class: '6th Std', rank: '3rd Rank', image: '6d3.jpg' },
  { name: 'Vaishnavi D/O Bheemashankar', class: '7th Std', rank: '1st Rank', image: '7d1.jpg' },
  { name: 'Krutika D/O Nagamurti', class: '7th Std', rank: '2nd Rank', image: '7d2.jpg' },
  { name: 'Shivani D/O Shrisail', class: '7th Std', rank: '3rd Rank', image: '7d3.jpg' },
  { name: 'Shreeraksha D/O Sudeer', class: '8th Std', rank: '1st Rank', image: '8d1.jpg' },
];

const TopperBanner = () => {
  return (
    <div className="topper-banner-wrapper">
      <div className="topper-banner-content">
        <h2 className="topper-heading">Topper's Achievements</h2>
        <div className="topper-grid">
          {toppers.map((topper, index) => (
            <div key={index} className="topper-card">
              <img
                src={require(`./topper/${topper.image}`)}
                alt={topper.name}
                className="topper-img"
              />
              <h3 className="topper-name">{topper.name}</h3>
              <p className="topper-class">{topper.class}</p>
              <p className="topper-rank">{topper.rank}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopperBanner;
